var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"bt-whatsapp",attrs:{"href":_vm.whatsappLink(),"target":"_blank"}},[_c('img',{attrs:{"src":_vm.image,"alt":"","width":"60px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }